var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
const qualification = namespace('qualification');
let ClaimTypeQuestion = class ClaimTypeQuestion extends QuestionComponent {
    get answer() {
        return this.$tc('claim.type.sumup', 0, { type: this.$tc('claim.type.' + this.type) });
    }
};
__decorate([
    qualification.State('typeTrigram')
], ClaimTypeQuestion.prototype, "type", void 0);
ClaimTypeQuestion = __decorate([
    Component({
        components: { QuestionPanel },
        props: QuestionProps,
    })
], ClaimTypeQuestion);
export default ClaimTypeQuestion;
